// extracted by mini-css-extract-plugin
export default {"container":"ChangeMonths_container__XlWzR","button":"ChangeMonths_button__Hh4Rm","arrowForth":"ChangeMonths_arrowForth__UTi1H","title":"ChangeMonths_title__3H2i1"};